export const pagination = {
  next: 'Next page',
  more: 'More',
}
